import React from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import { getUserData } from '../../actions/userdata';
import { toggleLoader } from '../../actions/loader';
import LeftbarAdmin from './LeftbarAdmin';
import LeftbarHospital from './LeftbarHospital';
import LeftbarChannel from './LeftbarChannel';
const Leftbar = (props) => {
  return (
    <>

      <LeftbarAdmin />

    </>
  );
}

const mapDispatchToProps = {
  toggleLoader, getUserData
}
const mapStateToProps = (state) => {
  return {
    userdata: state.userdata?.userData,

  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Leftbar);